"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_dom_1 = require("react-dom");
exports.useRootPortal = function (render, rootElId) {
    var rootEl = react_1.useMemo(function () {
        var existingEl = document.getElementById(rootElId);
        if (!existingEl) {
            var fixedEl = document.createElement('div');
            fixedEl.id = rootElId;
            document.body.prepend(fixedEl);
            return fixedEl;
        }
        return existingEl;
    }, [rootElId]);
    return react_dom_1.createPortal(render, rootEl);
};
